export const LIST_ITEMS_COUNT = 10;
